<script lang="ts" setup>
import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';

const displayVariants = {
  long: 'long',
  short: 'short',
} as const;

export type Variant = (typeof displayVariants)[keyof typeof displayVariants];

const props = defineProps({
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
  variant: { type: String as PropType<Variant>, default: 'long' },
});

const { t } = useI18n({ useScope: 'global' });

const timeInForce = computed(() => {
  if (props.order.displayedTimeInForce) {
    const tif = t(`modules.orderForm.advancedOptions.timeInForceNamesShort.${props.order.displayedTimeInForce}`);

    return ` (${tif})`;
  }

  return undefined;
});
const typeShort = computed(() => (props.order.type ? t(`modules.accountHistory.orders.type.${props.order.type}_SHORT`) : ''));
const typeLong = computed(() => (props.order.type ? t(`modules.accountHistory.orders.type.${props.order.type}`) : ''));
const items = computed(() => {
  let values;

  if (props.variant === displayVariants.short) {
    values = [
      {
        key: displayVariants.short,
        value: typeShort.value,
        class: 'order-display-type--type',
      },
    ];
  } else {
    values = [
      {
        key: displayVariants.long,
        value: typeLong.value,
        class: 'order-display-type--type',
      },
    ];
  }

  if (timeInForce.value) {
    values.push({
      key: 'advanced',
      value: timeInForce.value,
      class: 'order-display-type--advanced-type',
    });
  }

  return values;
});
</script>

<template>
  <div class="order-display-type">
    <span
      v-for="item in items"
      :key="item.key"
      :class="item.class"
    >
      {{ item.value }}
    </span>
  </div>
</template>

<style lang="scss">
.order-display-type {
  display: inline;

  &--advanced-type {
    color: var(--advanced-type-color, rgb(var(--v-theme-text-secondary)));

    .xs & {
      color: var(--advanced-type-color, rgb(var(--v-theme-text-tertiary)));
    }
  }
}
</style>
